import { useSelector } from 'react-redux'
import { defaultLocale } from 'src/configurations'
import { getLocaleInfo } from 'src/localization/locales'
import { createTranslate, TranslateFn } from 'src/localization/translate'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'
import { selectBrandName } from 'src/redux/selectors/session.selectors'

export const useTranslate = (): TranslateFn => {
  const whitelabelBrand = useSelector(selectBrandName)
  const locale = useSelector(selectNullSafeLocaleFromState)

  return createTranslate(
    getLocaleInfo(locale, whitelabelBrand).jsonTranslations,
    getLocaleInfo(defaultLocale, whitelabelBrand).jsonTranslations,
  )
}
